'use client';

import Link from 'next/link';
import { Button, Group, Stack, Text, Title } from '@mantine/core';
import { IconArrowLeft, IconExternalLink, IconSettings } from '@tabler/icons-react';
import classes from './portal.module.css';
import { useLocale } from '../lib/i18n/use_locale';
import { PORTAL_REGIONS } from '../lib/i18n/portal';
import { PORTAL_UI } from '../lib/i18n/strings';

// Menu of the regional EchoPlay developer portals. Documentation itself is no
// longer served in-app: the portal ingests the `docs/` corpus shipped in this
// repository and renders it. Labels follow the language chosen in /settings.

export default function PortalClient() {
  const locale = useLocale();

  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <div className={classes.header}>
          <div className={classes.headerText}>
            <Title order={1} c="#ffffff">
              {PORTAL_UI.pageTitle[locale]}
            </Title>
            <Text size="sm" c="#b8b8b8" mt={6} maw={560}>
              {PORTAL_UI.pageSubtitle[locale]}
            </Text>
            <Group gap="sm" mt="md">
              <Button
                component={Link}
                href="/"
                variant="light"
                color="gray"
                size="xs"
                leftSection={<IconArrowLeft size={15} />}
              >
                {PORTAL_UI.backToDemo[locale]}
              </Button>
              <Button
                component={Link}
                href="/settings"
                variant="subtle"
                color="gray"
                size="xs"
                leftSection={<IconSettings size={15} />}
              >
                {PORTAL_UI.openSettings[locale]}
              </Button>
            </Group>
          </div>
        </div>

        <Title order={2} c="#ffffff" mt="xl" size="h4">
          {PORTAL_UI.regionsHeading[locale]}
        </Title>

        <nav className={classes.regions} aria-label={PORTAL_UI.regionsHeading[locale]}>
          {PORTAL_REGIONS.map((region) => (
            <a
              key={region.id}
              href={region.url}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.regionCard}
            >
              <Stack gap={4}>
                <Group gap={6} wrap="nowrap">
                  <Text fw={600} c="#ffffff">
                    {region.name[locale]}
                  </Text>
                  <IconExternalLink size={14} color="#8a8a8a" />
                </Group>
                <Text size="sm" c="#c8ccd4">
                  {region.description[locale]}
                </Text>
                <span className={classes.regionUrl}>{region.url}</span>
                <Text size="xs" c="#8a8a8a">
                  {PORTAL_UI.opensInNewTab[locale]}
                </Text>
              </Stack>
            </a>
          ))}
        </nav>

        <Text size="xs" c="#8a8a8a" className={classes.footnote}>
          {PORTAL_UI.languageNote[locale]}
        </Text>
      </div>
    </div>
  );
}
